import { BellOutlined } from "@ant-design/icons";
import { CardItemStyled, CardTitle, KMdTextSecondary65 } from "@components";
import { useKContext } from "@context";
import { ICombinedCard } from "@types";
import { formatDate } from "@utils/date";
import { useCallback } from "react";
import { CardItemContainer } from "../share-component";
import { getInfoCard } from "@utils/cardTypeIcon";

export const ReminderItem = ({ card }: { card?: ICombinedCard }) => {
  const { reminder, _id, profile, cardType, title } = card || {};
  const { setCardTypeSelected, navigateDetailCard } = useKContext();

  const onClickItem = useCallback(() => {
    navigateDetailCard(cardType, _id, profile);
    setCardTypeSelected(cardType);
  }, [_id, cardType, profile]);

  if (!reminder) return null;

  return (
    <CardItemStyled $showBorder={false} onClick={onClickItem}>
      <CardItemContainer card={card}>
        <CardTitle icon={getInfoCard(cardType)?.icon}>{title}</CardTitle>
        {reminder.startTime && (
          <KMdTextSecondary65 $ellipsis numberOfLines={2}>
            {formatDate(reminder.startTime, "FULL_MONTH_YEAR_WITH_TIME_AM_PM")}
          </KMdTextSecondary65>
        )}
      </CardItemContainer>
    </CardItemStyled>
  );
};
